const BASE_URL = 'https://api.getvisitapp.net/stoker';
const BACKEND_TS_BASE_URL = 'https://api.samuraijack.xyz/backend-ts';
const PHARMACY_SERVICE_URL = 'https://api.getvisitapp.net/absol';
const NETWORK_SERVICE_URL = 'https://network.getvisitapp.net';
const KEA_APP_URL = 'https://hospital-dashboard.getvisitapp.net/vision';
const OPS_DASHBOARD_URL = 'https://operations.getvisitapp.net/';
const MAORI_DASHBOARD_URL = 'https://maori.getvisitapp.net/';
const CATALYST_DASHBOARD_URL = 'https://catalyst.getvisitapp.com/welcome';
const DOCTOR_DASHBOARD_URL = 'https://treat.samuraijack.xyz/home/';
const PAYMENT_SERVICE_URL = 'https://payments.getvisitapp.com';

const staging = {
  baseUrl: BASE_URL,
  backendTsBaseUrl: BACKEND_TS_BASE_URL,
  pharmacyService: PHARMACY_SERVICE_URL,
  networkService: NETWORK_SERVICE_URL,
  keaAppUrl: KEA_APP_URL,
  pubnub: {
    publishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    subscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
  },
  googleAuthConfig: {
    clientId:
      '1063005261362-ahma70ju5no6aksoc95p9kivj7s3uopp.apps.googleusercontent.com',
    scopes: ['email', 'profile', 'openid'],
  },
  opsDashboardURL: OPS_DASHBOARD_URL,
  maoriDashboardURL: MAORI_DASHBOARD_URL,
  catalystDashboardURL: CATALYST_DASHBOARD_URL,
  doctorDashboardUrl: DOCTOR_DASHBOARD_URL,
  paymentServiceUrl: PAYMENT_SERVICE_URL,
  useTestAuthProxy: true,
  starHealthAccess: {
    allowedUserIds: [
      '263',
      '298',
      '789',
      // Add your allowed userIds here
    ],
  },
  pacAccess: {
    allowedUserIds: [
      '263',
      '298',
      '789',
      // Add your allowed userIds here
    ],
  },
};

export default staging;
